import React, { FC } from 'react';

const GeminiNavSeparator: FC = () => (
  <div className='bg-new-gray w-[1.5px] h-full mx-[50px]' />
);

export default GeminiNavSeparator;
